<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <el-scrollbar>
                <BuildTree ref="buildTree" :sourceData="treeData" @handleNodeClick="handleNodeClick" />
            </el-scrollbar>
        </div>
        <div class="data-container" center-area>
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="refreshTime">刷新</el-button>
                <el-button :icon="Upload" @click="exportData" v-permission="['pipeline-sensor:monitoring:batch-export']">
                    最新数据导出
                </el-button>
                <div class="total-box">
                    <span class="all">全部：{{ onlineNum + offlineNum }}</span>
                    <span class="online">在线：{{ onlineNum }}</span>
                    <span class="offline">离线：{{ offlineNum }}</span>
                    <span class="time">更新时间：</span>
                    <span class="time">{{ dateTime }}</span>
                </div>
            </div>
            <el-form class="search-form" :model="queryForms" label-position="top" inline>
                <el-form-item label="户名">
                    <el-input style="width: 165px" v-model="queryForms.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryForms.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="queryForms.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="queryForms.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="handleSearch">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                scrollbar-always-on
            >
                <el-table-column type="selection" width="30" align="center"></el-table-column>
                <el-table-column label="序号" type="index" fixed="left" width="60" align="center"></el-table-column>
                <el-table-column label="户名" fixed="left" prop="name" width="110" show-overflow-tooltip></el-table-column>
                <el-table-column label="IMEI" width="150" prop="IMEI"></el-table-column>
                <el-table-column label="状态" width="65" prop="online" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.online" type="success">在线</el-tag>
                        <el-tag v-else type="danger">离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="100px" prop="roomtemp">
                    <template #header>
                        <p>入水温度</p>
                        <p>(℃)</p>
                    </template>
                    <template #default="{ row }">
                        <span v-if="row.roomtemp && row.roomtemp <= 100">
                            {{ (Math.round(row.roomtemp * 10) / 10).toFixed(1) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column width="100px" prop="enter_temp">
                    <template #header>
                        <p>出水温度</p>
                        <p>(℃)</p>
                    </template>
                    <template #default="{ row }">
                        <template v-if="row.enter_temp && row.enter_temp <= 100">
                            {{ Math.round(row.enter_temp) }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="信号强度" width="90px" prop="signal_strength">
                    <template #default="{ row }">
                        <div class="signal-box">
                            <span class="num">{{ row.csq }}</span>
                            <div class="signal">
                                <span
                                    v-for="num of 5"
                                    class="bar"
                                    :key="num"
                                    :class="['bar' + num, num <= Math.floor(row.csq / 6) ? 'active' : '']"
                                ></span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="上传时间" prop="ts" min-width="160"></el-table-column>
                <el-table-column label="采集时间" prop="data_ts" min-width="160"></el-table-column>
                <el-table-column label="安装位置" min-width="250px" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span v-show="row.room">{{ room_list[row.room] }}</span>
                        <span v-show="row.location">/{{ row.location }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="上传周期" width="110px" prop="upload_cycle">
                    <template #header>
                        <p>上传周期</p>
                        <p>(分钟)</p>
                    </template>
                    <template #default="{ row }">{{ row.report_cycle }}</template>
                </el-table-column>
                <el-table-column label="电池电量" width="90px" prop="battery_level">
                    <template #header>
                        <p>电池电量</p>
                        <p>(%)</p>
                    </template>
                    <template #default="{ row }">
                        <span v-if="row.bat <= 100">{{ row.bat }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="告警标记" width="160px" prop="alarm_flag">
                    <template #default="{ row }">
                        <el-tag v-if="row.power_fault" type="danger">掉电故障</el-tag>
                        <el-tag v-if="row.displacement_fault" type="danger">位移故障</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column label="ICCID" prop="ICCID" min-width="200"></el-table-column>
                <el-table-column label="安装图片" prop="install_pics" min-width="130">
                    <template #default="{ row }">
                        <div class="install-pic-list" v-if="row.install_pics.length > 0">
                            <el-image
                                style="width: 50px; height: 50px"
                                :src="row.install_pics[0]"
                                :preview-src-list="row.install_pics"
                                fit="cover"
                            />
                            <el-image
                                style="width: 50px; height: 50px"
                                :src="row.install_pics[1]"
                                :preview-src-list="row.install_pics"
                                fit="cover"
                            />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160px" fixed="right">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            @click="viewRecord(row)"
                            v-permission="['pipeline-sensor:monitoring:record']"
                        >
                            历史数据
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            @click="viewChart(row.id)"
                            v-permission="['pipeline-sensor:monitoring:chart']"
                        >
                            数据曲线
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <record-dialog v-model="show_record_dialog" :deviceId="device_id" :IMEI="device_IMEI" />
            <chart-dialog v-model="show_chart_dialog" :deviceId="device_id" />
            <el-pagination
                class="pagination"
                v-if="table_data.length > 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForms.page"
                :page-size="queryForms.page_size"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
        </div>
        <div class="alarm-container right-area">
            <alarm-list more-page-path="/pipeline-sensors/pipeline-history-event" :type="2"></alarm-list>
        </div>
    </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import BuildTree from '@/components/BuildTree/index'
import { getDevicesRecord } from '@/api/heating/monitoring.js'
import { Refresh, Search, Upload } from '@element-plus/icons'
import AlarmList from '@/components/Equipment/List/index'
import { getDeviceList } from '@/api/heating/devicePoint/devicePoint.js'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import RecordDialog from './components/RecordDialog.vue'
import ChartDialog from './components/ChartDialog.vue'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'

// 切换楼层数据
const current_node = ref({})
const handleNodeClick = (row) => {
    current_node.value = row.node
    getTableData()
}

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    const room_locations = {}
    function getRoom(list, location) {
        list.forEach((item) => {
            if (item.children) {
                getRoom(item.children, location + '/' + item.name)
            } else {
                room_locations[item.id] = location.slice(1) + '/' + item.name
            }
        })
    }
    await getOptionTree().then((data) => {
        getRoom(data[0]?.children ?? [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 数据源
const queryForms = ref({
    name: '',
    online: '',
    building: '',
    page: 1,
    page_size: 20
})
const total = ref(0)
// 在线离线数量
const onlineNum = ref(0)
const offlineNum = ref(0)
// 重置
const resetQueryForm = () => {
    queryForms.value = {
        name: '',
        online: '',
        building: '',
        page: 1,
        page_size: 20
    }
    total.value = 0
    getTableData()
}
// 搜索回到第一页
const handleSearch = () => {
    queryForms.value.page = 1
    getTableData()
}
// 格式化对象
const getNowDate = () => {
    const date = new Date()
    const sign2 = ':'
    const year = date.getFullYear() // 年
    let month = date.getMonth() + 1 // 月
    let day = date.getDate() // 日
    let hour = date.getHours() // 时
    let minutes = date.getMinutes() // 分
    let seconds = date.getSeconds() // 秒
    if (month >= 1 && month <= 9) {
        month = '0' + month
    }
    if (day >= 0 && day <= 9) {
        day = '0' + day
    }
    if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds
    }
    return year + '-' + month + '-' + day + ' ' + hour + sign2 + minutes + sign2 + seconds
}

// 获取左侧树状结构
const treeData = ref([])
const treeLoading = ref(false)
async function getTreeData() {
    treeLoading.value = true
    await getOptionTree().then((data) => {
        const roomAddLevel = (list, level = 1) => {
            list.forEach((item) => {
                item.is_leaf = false
                item.level = level
                if (item.children) {
                    roomAddLevel(item.children, item.level + 1)
                }
            })
        }
        roomAddLevel(data, 1)
        treeData.value = data
        nextTick(() => {
            current_node.value = treeData.value[0]
        })
    })
    treeLoading.value = false
}

// 刷新时间
const dateTime = ref('')
dateTime.value = getNowDate()
const refreshTime = async () => {
    dateTime.value = getNowDate()
    resetQueryForm()
}

// 表格数据
const table_data = ref([])
const tableLoading = ref(false)
const getTableData = async () => {
    tableLoading.value = true
    const params = { ...queryForms.value }
    if (params.online === '') delete params.online
    if (current_node.value?.level < 6) {
        params.building = current_node.value.id
    } else if (current_node.value?.level === 6) {
        params.room = current_node.value.id
    }
    params.type = 2
    getDeviceList(params).then((data) => {
        onlineNum.value = data.online_count
        offlineNum.value = data.offline_count
        table_data.value = data.lists
        total.value = data.total
        tableLoading.value = false
    })
}

// 分页
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    queryForms.value.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getTableData()
}

// 表格多选
const selected_list = ref([])
function handleSelectionChange(list) {
    selected_list.value = list.map((item) => {
        return item.id
    })
}

// 最新数据导出
function exportData() {
    ElMessageBox.confirm('是否确认导出设备数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let list = []
            await getDevicesRecord({
                type: 2,
                devices: selected_list.value
            }).then((data) => {
                list = data
            })
            if (list.length <= 0) {
                loading.close()
                return ElMessage.error('没有数据可导出')
            }

            // 创建excel并写入数据
            let workbook = null
            workbook = new Exceljs.Workbook()
            workbook.created = new Date()
            workbook.modified = new Date()
            workbook.lastPrinted = new Date()
            const worksheet = workbook.addWorksheet('设备数据', {
                properties: {
                    defaultRowHeight: 22
                },
                pageSetup: {
                    horizontalCentered: true
                }
            })

            worksheet.columns = [
                {
                    header: '序号',
                    key: 'index',
                    width: 10
                },
                {
                    header: '安装地址',
                    key: 'address',
                    width: 50
                },
                {
                    header: '热力站名称',
                    key: 'station',
                    width: 30
                },
                {
                    header: '小区名称',
                    key: 'residential_name',
                    width: 20
                },
                {
                    header: '楼栋',
                    key: 'building',
                    width: 10
                },
                {
                    header: '单元',
                    key: 'unit',
                    width: 10
                },
                {
                    header: '楼层',
                    key: 'floor',
                    width: 10
                },
                {
                    header: '房间',
                    key: 'room',
                    width: 20
                },
                {
                    header: '户名',
                    key: 'name',
                    width: 20
                },
                {
                    header: '联系电话',
                    key: 'phone',
                    width: 30
                },
                {
                    header: '型号规格',
                    key: 'model',
                    width: 20
                },
                {
                    header: '设备编号（IMEI）',
                    key: 'IMEI',
                    width: 50
                },
                {
                    header: '上传时间',
                    key: 'ts',
                    width: 22
                },
                {
                    header: '采集时间',
                    key: 'data_ts',
                    width: 22
                },
                {
                    header: '入水温度（℃）',
                    key: 'roottemp',
                    width: 15
                },
                {
                    header: '出水温度（℃）',
                    key: 'humidity',
                    width: 15
                },
                {
                    header: '信号强度',
                    key: 'csq',
                    width: 15
                },
                {
                    header: '电池电量（%）',
                    key: 'bat',
                    width: 15
                },
                // {
                //     header: '告警标记',
                //     key: 'alarm_flags',
                //     width: 20
                // },
                {
                    header: '补偿温度',
                    key: 'temperature_compensation',
                    width: 20
                },
                {
                    header: '上报周期',
                    key: 'upperi',
                    width: 20
                },
                {
                    header: '是否显示',
                    key: 'show_panel',
                    width: 20
                },
                {
                    header: '是否在线',
                    key: 'online',
                    width: 20
                },
                {
                    header: '版本号',
                    key: 'version',
                    width: 20
                },
                {
                    header: 'ICCID',
                    key: 'iccid',
                    width: 20
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        index: item.index,
                        address: item.address,
                        station: item.station,
                        residential_name: item.location[1],
                        building: item.location[2],
                        unit: item.location[3],
                        floor: item.location[4],
                        room: item.location[5],
                        name: item.name,
                        phone: item.phone,
                        model: model_list.value[item.model]
                            ? model_list.value[item.model].type + '/' + model_list.value[item.model].model
                            : '',
                        IMEI: item.IMEI,
                        ts: item.ts,
                        data_ts: item.data_ts,
                        roottemp: item.roottemp,
                        humidity: item.humidity <= 100 ? item.humidity : '',
                        csq: item.csq,
                        bat: item.bat,
                        alarm_flags:
                            ((item.flags & (1 << 7)) !== 0 ? '掉电故障' : '') +
                            ((item.flags & (1 << 7)) !== 0 && (item.flags & (1 << 6)) !== 0 ? '，' : '') +
                            ((item.flags & (1 << 6)) !== 0 ? '移位故障' : ''),
                        temperature_compensation: item.temperature_compensation,
                        upperi: item.upperi,
                        show_panel: item.show_panel ? '显示' : '不显示',
                        online: item.online ? '在线' : '离线',
                        version: item.version,
                        iccid: item.iccid
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            // 导出excel文件
            await workbook.xlsx.writeBuffer().then((buffer) => {
                const date = new Date()
                const year = date.getFullYear() // 年
                let month = date.getMonth() + 1 // 月
                let day = date.getDate() // 日
                let hour = date.getHours() // 时
                let minutes = date.getMinutes() // 分
                let seconds = date.getSeconds() // 秒
                // 给一位数的数据前面加 “0”
                if (month >= 1 && month <= 9) month = '0' + month
                if (day >= 0 && day <= 9) day = '0' + day
                if (hour >= 0 && hour <= 9) hour = '0' + hour
                if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
                if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds
                const presentDate = `管道传感器最新监测数据${year}${month}${day}${hour}${minutes}${seconds}`

                // 导出并存储文件
                FileSaver.saveAs(new Blob([buffer]), `${presentDate}.xlsx`)
            })
            loading.close()
        })
        .catch(() => {})
}

// 选中的设备id
const device_id = ref('') // 点中的模块id

const device_IMEI = ref('')

// 查看历史采集数据
const show_record_dialog = ref(false)
function viewRecord(row) {
    device_id.value = row.id
    device_IMEI.value = row.IMEI
    show_record_dialog.value = true
}

// 数据曲线
const show_chart_dialog = ref(false)
function viewChart(id) {
    device_id.value = id
    show_chart_dialog.value = true
}

onMounted(async () => {
    tableLoading.value = true
    await getTreeData()
    await getModelList()
    await getRoomTree()
    await getTableData()
})
</script>

<style lang="scss" scoped>
.install-pic-list {
    width: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
